import { BackendResponse } from '../../types/interfaces';
import { MappingService } from './mapping.service';

export const deserializeResponse = <T>(
  response: BackendResponse<T>,
  clazz: new () => any
): BackendResponse<T> => {
  const { status, message, data } = response;
  let convertedData: T;
  if (Array.isArray(data)) {
    //@ts-ignore
    convertedData = data.map((param: any) => {
      if (typeof param === 'object') {
        return MappingService.deserialize(clazz, param) as T;
      } else {
        return param;
      }
    });
  } else {
    convertedData = MappingService.deserialize(clazz, data);
  }
  return { status, message, data: convertedData };
};

export const replaceUrlParams = (
  url: string,
  paramNames: any[],
  paramValues: any[]
): string => {
  if (paramNames.length !== paramValues.length) {
    throw new Error(
      'Number of parameter names must match number of parameter values'
    );
  }
  paramNames.forEach((paramName, index) => {
    const paramValue = paramValues[index];
    url = url.replace(
      new RegExp(`{{${paramName}}}`, 'g'),
      paramValue.toString()
    );
  });

  return url;
};

export const handleGender = (gender: string, full: boolean = true) => {
  switch (gender) {
    case 'MALE':
      return full ? 'Herr' : 'Hr.';
    case 'FEMALE':
      return full ? 'Frau' : 'Fr.';
    case 'UNISEX':
      return '';
    case 'NONE':
      return '';
    case 'UNKNOWN':
      return '';
    default:
      return '';
  }
};
